import type React from 'react';
import type { CSSProperties, ImgHTMLAttributes } from 'react';
import { memo, useEffect, useState } from 'react';
import { BLUR_IMAGE_PLACEHOLDER } from './helpers';

type ImageProps = Omit<
  ImgHTMLAttributes<HTMLImageElement>,
  'src' | 'width' | 'height'
> & {
  src: string;
  alt: string;
  placeholderSrc?: string;
} & (
    | {
        fill: true;
      }
    | {
        width: string | number;
        height: string | number;
      }
  );

export type IImageComponentProps = ImageProps;

export const ImageComponent: React.FC<IImageComponentProps> = memo(
  ({
    src,
    alt,
    className,
    placeholderSrc = BLUR_IMAGE_PLACEHOLDER,
    ...props
  }) => {
    const [imgSrc, setImgSrc] = useState(src);

    const handleError = () => {
      console.error('Image failed to load:', src);
      setImgSrc(placeholderSrc);
    };

    const fill = 'fill' in props && props.fill === true;

    const imageStyle: CSSProperties = fill
      ? {
          position: 'absolute',
          height: '100%',
          width: '100%',
          inset: 0,
          objectFit: 'cover',
        }
      : {};

    useEffect(() => {
      if (src) {
        setImgSrc(src);
      }
    }, [src]);

    return (
      <img
        alt={alt}
        className={className}
        onError={handleError}
        src={imgSrc}
        style={imageStyle}
        {...('width' in props && { width: props.width })}
        {...('height' in props && { height: props.height })}
      />
    );
  }
);
